import React from 'react';
import { Typography } from '@mui/material';
import Table from '../../../../components/tables/Table';
import tableStyles from '../../../../components/tables/Table.styles';
import { fmtDateGB } from '../../utils/meterVersion.helpers';
import { useNavigate } from 'react-router-dom';
import { useNavWithTrail } from '../../../../layouts/TrailProvider';

const COLUMNS = [
  {
    label: 'Status',
    field: 'unitStatus',
    type: 'string',
    sortable: true,
    render: (_row, v) => v || '—',
  },
  {
    label: 'Unit',
    field: 'TrainNumber',
    type: 'string',
    sortable: true,
    render: (_row, v, nav) =>
      v ? (
        <Typography
          sx={tableStyles.tableLink}
          onClick={() => nav(`/home/units/${encodeURIComponent(v)}`)}
        >
          {v}
        </Typography>
      ) : (
        '—'
      ),
  },
  {
    label: 'EVN',
    field: 'EVN',
    type: 'string',
    sortable: true,
    render: (_row, v, nav) =>
      v ? (
        <Typography
          sx={tableStyles.tableLink}
          onClick={() => nav(`/home/evns/${encodeURIComponent(v)}`)}
        >
          {v}
        </Typography>
      ) : (
        '—'
      ),
  },
  {
    label: 'Comments',
    field: 'Comments',
    type: 'string',
    sortable: true,
    render: (_row, v) => (typeof v === 'string' ? v : '') || '—',
  },
  {
    label: 'From',
    field: 'FromDate',
    type: 'date',
    sortable: true,
    render: (_row, v) => fmtDateGB(v),
  },
  {
    label: 'To',
    field: 'ToDate',
    type: 'date',
    sortable: true,
    render: (_row, v) => fmtDateGB(v),
  },
  {
    label: 'Faulty',
    field: 'Faulty',
    type: 'boolean',
    sortable: true,
    accessor: (row) => row?.Faulty === true || row?.Faulty === 1 || row?.Faulty === '1',
  },
  {
    label: 'Recorded On',
    field: 'AssignmentRecordedOn',
    type: 'date',
    sortable: true,
    render: (_row, v) => fmtDateGB(v),
  },
];

export default function MeterVersionTable({ rows = [] }) {
  const navigate = useNavigate();
  const nav = useNavWithTrail(navigate);

  const columnsWithNav = COLUMNS.map((c) =>
    c.render ? { ...c, render: (row, value) => c.render(row, value ?? row?.[c.field], nav) } : c
  );

  return (
    <Table
      rows={Array.isArray(rows) ? rows : []}
      columns={columnsWithNav}
      stickyHeader
      zebra
      hover
      bordered

    />
  );
}
